export default __webpack_public_path__ + "static/media/6_3_hl.f47ed4ef.png";